import { UIPopularFlightInfo } from "@flights/types";

export type State = UIPopularFlightInfo[] | null;

export const getInitialState = (): State => null;
